import { Injectable } from '@angular/core';
import { BaseApi } from '../../laas/base-api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ViewCbsApprovedService {
  adminId: string;
  baseUrl: string;
  private applicantId: string;
  public isRetail: boolean;

  constructor(private api: BaseApi) {
    this.applicantId = this.getApplicantID();
    this.adminId = sessionStorage.getItem('wl-admin-id');
    this.baseUrl = `/applicants/${this.applicantId}`;
  }

  getApplicantID() {
    return sessionStorage.getItem('wl-applicant-id');
  }

  getUsersSearch(input, roleId, offset, limit, page) {
    let dataObj = {
      adminId: this.adminId,
      roleId: sessionStorage.getItem('getroleId'),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'Pending',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    let filterDate = sessionStorage.getItem('filterDateViewConsent')
      ? sessionStorage.getItem('filterDateViewConsent')
      : '';
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    return this.api.newPost(`/users/userSearch`, dataObj, true).pipe(map((res) => {
      if (!res.result) {
        return '';
      }
      let i = page * 10 - 9;
      if (res && res.result && res.result.resultData) {
        res.result.resultData.forEach((user) => (user.srNo = i++));
      }
      return res;
    }));
  }

  getUsers(input, roleId, offset, limit, userSearchParameter) {
    let dataObj = {
      adminId: this.adminId,
      roleId: sessionStorage.getItem('getroleId'),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: userSearchParameter,
      date_type: 'dateRange',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    // let filterDate = sessionStorage.getItem('filterDateViewConsent')?sessionStorage.getItem('filterDateViewConsent'):'';
    // if(filterDate){
    //       let date = new Date(filterDate);
    //       let dateInMs = date.getTime();
    //        dataObj['filter_date']=dateInMs;
    //     }
    if (
      sessionStorage.getItem('filterDateViewCustomerReassignedStart') &&
      sessionStorage.getItem('filterDateViewCustomerReassignedEnd')
    ) {
      console.log('inside service');
      dataObj['filter_date'] = parseInt(
        sessionStorage.getItem('filterDateViewCustomerReassignedStart')
      );
      dataObj['end_date'] = parseInt(sessionStorage.getItem('filterDateViewCustomerReassignedEnd'));
    }

    return this.api.postRes('/users/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }));

    // return this.api.newPost(`/users/search-users/${page}`, { input: input ? input : '' }, true).map(res => {
    //   if (!res.result) {
    //     return '';
    //   }
    //   let i = page * 10 - 9;
    //   res.result.forEach(user => user.srNo = i++)
    //   return res;
    // })
  }

  getUsersFilterDate(
    input,
    roleId,
    offset,
    limit,
    filterDate,
    userSearchParameter,
    endDateInMs,
    dateType
  ) {
    let dataObj = {
      adminId: this.adminId,
      roleId: sessionStorage.getItem('getroleId'),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: userSearchParameter,
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    let filterDate1 = sessionStorage.getItem('filterDateViewConsent')
      ? sessionStorage.getItem('filterDateViewConsent')
      : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    return this.api.postRes('/users/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }));
  }

  generateInvoice(custName, custId, custMail, isRetail) {
    let dataObj = {
      adminId: this.adminId,
      custName: custName,
      custId: custId,
      email: custMail,
      isRetail: isRetail,
    };
    return this.api.postRes('/users/generateBill', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }));
  }

  getRocCounts() {
    return this.api.newGet(`/pdf/getCount/roc`).pipe(map((res) => {
      return res;
    }));
  }

  generateLogReport() {
    return this.api.newGet(`/pdf/getLogDataForAdmin/${this.adminId}`).pipe(map((report) => {
      console.log(report);
      return report;
    }));
  }

  getCoApplicants(custId) {
    return this.api.postRes('/users/getCoApplicants', { custId: custId }).pipe(map((resp) => {
      console.log('resp in service ' + JSON.stringify(resp));
      return resp;
    }));
  }

  getGuarantors(custId) {
    return this.api.postRes('/users/getguarantors', { custId: custId }).pipe(map((resp) => {
      console.log('resp in service ' + JSON.stringify(resp));
      return resp;
    }));
  }

  getRoleId() {
    return sessionStorage.getItem('getroleId');
  }

  getCbsApproved(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: payload.searchFilter,
    };

    return this.api.postRes('/users/userSearch', desiredPayload).pipe(map((resp) => {
      return resp;
    }));
  }

  parseDateString = (dateString: string) => {
    const parts = dateString.split('-');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  };
}
